<template>
  <label class="radio-input flex items-start text-lg cursor-pointer w-fit">
    <input
      v-model="model"
      type="radio"
      class="!cursor-pointer mt-1.5 w-4 h-4"
      :value="value"
    >

    <p class="flex justify-center flex-col ml-3.5 mb-0">
      <span>
        {{ label }}
      </span>

      <template v-if="hint">
        <span
          class="text-gray-500 text-sm font-normal text-left mb-3 last:mb-0"
        >
          {{ hint }}
        </span>
      </template>
    </p>
  </label>
</template>

<script setup>

defineProps({
  label: {
    type: String,
    default: '',
  },
  hint: {
    type: String,
    default: '',
  },
  value: {
    type: String,
    default: '',
  },
});

const model = defineModel();

</script>
